module.exports = __webpack_public_path__ + "media/images/home-alternate-e2594c249c2d2ace5a4ad2c0dc093730.svg";